import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './SomeRoomsNotAvailablePopUp.css';
import { setShowSomeRoomsNotAvailableOnNewDates } from '../../../actions/Booking';
import closePopupIcon from '../../../static/images/closePopupIcon.png';

// eslint-disable-next-line no-unused-vars
const SomeRoomsNotAvailablePopUp = (props, context) => {
  const popupContentRef = useRef(null);

  const handleClickOutside = (event) => {
    if (popupContentRef.current && !popupContentRef.current.contains(event.target)) {
      props.dispatch(setShowSomeRoomsNotAvailableOnNewDates(false));
    }
  };

  useEffect(() => {
    // Agregar el event listener cuando el componente se monta
    document.addEventListener('mousedown', handleClickOutside);

    // Limpiar el event listener cuando el componente se desmonta
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []); // El array vacío asegura que esto solo se ejecute al montar/desmontar

  return (
    <div className="popup-overlay">
      <div className="popup-content" ref={popupContentRef}>
        <img src={closePopupIcon} alt="Close" className="popup-close"
          onClick={() => props.dispatch(setShowSomeRoomsNotAvailableOnNewDates(false))}/>
        <div>
          <h1 className='noAvailabilityTextTitle'>
            {context.t("We're sorry")}
          </h1>
          <br/>
          <h2 className='noAvailabilityTextSubTitle'>
            {context.t('This room is currently unavailable')}
          </h2>
        </div>
      </div>
    </div>
  );
};

SomeRoomsNotAvailablePopUp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  cart: PropTypes.object.isRequired,
};

SomeRoomsNotAvailablePopUp.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  lang: state.i18nState.lang,
  hotel: state.booking.hotel,
  cart: state.cart,
}))(SomeRoomsNotAvailablePopUp);
